module.exports = __webpack_public_path__ + "img/borderGemstoneWhite.32fa5a0f.svg";